import { ROUTES, history } from 'Utils/constants'
import { useDispatch } from 'react-redux'
import analytics from 'shared/Analytics'
import { COTIZACION_REMOVE, LOGOUT_USER } from 'redux/types'
import { notifyAuthLogout } from 'Utils/authSessionSync'

export const clearLocalSession = (
  dispatch,
  { redirectToLogin = true } = {}
) => {
  dispatch({ type: LOGOUT_USER })
  dispatch({ type: COTIZACION_REMOVE })

  if (redirectToLogin && history.location.pathname !== ROUTES.login) {
    history.push(ROUTES.login)
  }

  return Promise.resolve()
    .then(() => analytics.pause())
    .catch(error => {
      console.warn('No se pudo pausar Analytics al cerrar sesión:', error)
    })
}

export const useLogout = () => {
  const dispatch = useDispatch()

  const logout = async () => {
    notifyAuthLogout()
    await clearLocalSession(dispatch)
  }

  return { logout }
}
